import Panel from './Panel'

export default Panel



// WEBPACK FOOTER //
// ./src/components/panel/index.js